// Module
var code = "<template> <require from=\"app/um/components/summary/auth-summary\"></require> <compose view-model=\"app/um/components/summary/auth-summary\" model.bind=\"modelData\"></compose> </template> ";
// Exports
module.exports = code;